module.exports = __webpack_public_path__ + "static/img/pay_background.fa244dd.png";


//////////////////
// WEBPACK FOOTER
// ./static/ningbo/ningbo_log/pay_background.png
// module id = /uAc
// module chunks = 24